var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6, _g, _path7, _path8, _rect4, _path9, _rect5, _rect6, _rect7, _rect8, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 100,
    width: 164,
    height: 32,
    rx: 3,
    fill: "#FF5000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 102H22L8 116L22 130H39.5L25.5 116L39.5 102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 102H63L49 116L63 130H80.5L66.5 116L80.5 102Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 102H104L90 116L104 130H121.5L107.5 116L121.5 102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 102H145L131 116L145 130H162.5L148.5 116L162.5 102Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 133,
    width: 6,
    height: 20,
    fill: "#575656"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 133,
    width: 6,
    height: 20,
    fill: "#575656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8278 50.2266L10.8623 85.4936H33.1382L23.3681 50.2266H20.8278Z",
    fill: "#ED963D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7500_7117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 50,
    width: 24,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8278 50.0308L10.8623 85.2978H33.1382L23.3681 50.0308H20.8278Z",
    fill: "#ED963D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7500_7117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1606,
    y: 57.6716,
    width: 14.069,
    height: 5.09413,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0803,
    y: 67.8604,
    width: 24.2299,
    height: 9.40454,
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0117 78.8319L10.8623 85.4935H33.1382L28.8393 69.6233C28.8393 69.6233 30.0117 79.4197 22.9772 81.7708C16.529 83.926 13.0117 78.8319 13.0117 78.8319Z",
    fill: "#E68538",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7356 87.0613L11.0574 85.4939H32.9425L36.4597 87.0613H7.7356Z",
    fill: "#DE6536"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 86.8652,
    width: 34,
    height: 3.13485,
    fill: "#EC963F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2874 88.2367L39 86.8652V90.0001H5L35.2874 88.2367Z",
    fill: "#E48436"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.781767,
    height: 27.0424,
    rx: 0.390883,
    transform: "matrix(0.961666 0.274224 -0.272864 0.962053 21.4233 52.2188)",
    fill: "white",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 60,
    width: 4,
    height: 40,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 123.213,
    y: 22,
    width: 30,
    height: 30,
    rx: 2,
    transform: "rotate(45 123.213 22)",
    fill: "#F42E33"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 123.213,
    y: 25,
    width: 26,
    height: 26,
    rx: 2,
    transform: "rotate(45 123.213 25)",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.607 48.1317L121.213 35H125.415L125.048 48.1317H121.607ZM125.284 51.6773C125.284 52.2025 125.1 52.6665 124.732 53.0692C124.382 53.4544 123.91 53.647 123.314 53.647C122.719 53.647 122.237 53.4544 121.87 53.0692C121.52 52.6665 121.344 52.2025 121.344 51.6773C121.344 51.152 121.52 50.6968 121.87 50.3116C122.237 49.9089 122.719 49.7075 123.314 49.7075C123.892 49.7075 124.365 49.9089 124.732 50.3116C125.1 50.6968 125.284 51.152 125.284 51.6773Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/error403.8199db65cf5ac2dccc8f348991b0c603.svg";
export { ForwardRef as ReactComponent };